/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.uber.conference.rpc.AccountRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const buildOAuthUrlRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'buildOAuthUrl',
  auth: 'app',
  fingerprint: 'slGYIcMJVtjb0NjvAexiDZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkInstalledRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'checkInstalled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAyGuRJnzYclJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const connectRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'connect',
  auth: 'app',
  fingerprint: 'GkDtp6P5DWSlbwcxSM77JpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disconnectRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'disconnect',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACslsmQdtrL25wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disconnectForPortalByUserRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'disconnectForPortalByUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADpz_mrNA0EWZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectionStatusRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'getConnectionStatus',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABOKCB1NAIz65wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStatusRpc = {
  serviceName: 'com.hubspot.uber.conference.rpc.AccountRpc',
  rpcName: 'getStatus',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACIvey2j9fJmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};